import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { Router } from '@angular/router';
import { configuracion } from '../../recursos/config.service';

@Component({
  selector: 'app-tipo-beca-ajuste',
  templateUrl: './tipo-beca-ajuste.component.html',
  styleUrls: ['./tipo-beca-ajuste.component.css']
})
export class TipoBecaAjusteComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;

  public nombreBeca: string = "";
  public vecAjustes = []; public vecHora: Array<any>; public vecMin: Array<any>;

  constructor(private srvSelect: SeleccionService, private srvInsert: IngresoService, private alerti: AlertifyService) { }

  ngOnInit() {
    this.nombreBeca = localStorage.getItem('modNom');
    this.obtenerAjustesTipoBeca();
    this.instanciaAjustes(localStorage.getItem('modBeca'), 0, 0, 0, 'Términos y condiciones al postular a la beca',
      'Contexto del correo al finalizar la carga de requisitos',
      'Contexto del correo cuando la beca es aceptada y debe entregar los documentos',
      'se identificaron los cambios que se detallan a continucai&oacute;n, por lo que le solicitamos que actualice la informaci&oacute;n a la brevedad posible ',
      '1991-09-23T23:55', '1991-09-23T23:55', localStorage.getItem('idPersona'), '', 0);
    this.generarHorasMinutos();
  }
  //INSTACIAR EL VECTOR DE AJUSTES
  instanciaAjustes(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, dato11, dato12, dato13) {
    dato9 = dato9 == null ? '1991-09-23T23:55' : dato9; dato10 = dato10 == null ? '1991-09-23T23:55' : dato10;
    this.vecAjustes = [];
    this.vecAjustes.push({
      intTipoBeca: dato1, strPeriodo: dato2, intAdmite: dato3, intActualizar: dato4, strCondiciones: dato5, strMailCargaReq: dato6, strMailEntregaReq: dato7,
      strMailObservaReq: dato8,
      datFechaPostula: dato9.split('T')[0], datHoraPostula: dato9.split('T')[1].split(':')[0], datMinPostula: dato9.split('T')[1].split(':')[1],
      datFechaCarga: dato10.split('T')[0], datHoraCarga: dato10.split('T')[1].split(':')[0], datMinCarga: dato10.split('T')[1].split(':')[1],
      intPersona: dato11, datFecha: dato12, promedio: dato13
    });
  }
  //FUNCION QUE CARGA LOS AJUSTES REGISTRADOS 
  async obtenerAjustesTipoBeca() {
    //OBTENER EL PERIODO VIGENTE A LA FECHA ACTUAL
    const resPer = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(10, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resPer.success) {
      //OBTENER LOS AJUSTES DEL TIPO DE BECA
      const resAjuste = await new Promise<any>(resolve => this.srvSelect.gestionBecas(14, localStorage.getItem('modBeca'), resPer.carrera[0].strCodigo, 'na')
      .subscribe(translated => { resolve(translated) }));
      if (resAjuste.success)
        this.instanciaAjustes(resAjuste.becas[0].intTipoBeca, resPer.carrera[0].strCodigo, resAjuste.becas[0].intAdmite, resAjuste.becas[0].intActualizar,
          resAjuste.becas[0].strCondiciones, resAjuste.becas[0].strMailCargaReq, resAjuste.becas[0].strMailEntregaReq, resAjuste.becas[0].strMailObservaReq,
          resAjuste.becas[0].datFechaPostula, resAjuste.becas[0].datFechaCarga, resAjuste.becas[0].intPersona, resAjuste.becas[0].datFecha, resAjuste.becas[0].fltPromedioMin);
      else {
        const resAjusteAnt = await new Promise<any>(resolve =>
          this.srvSelect.gestionBecas(15, localStorage.getItem('modBeca'), resPer.carrera[0].strCodigo, 'na').subscribe(translated => {
            resolve(translated)
          }));
        if (resAjusteAnt.success) {
          this.instanciaAjustes(resAjusteAnt.becas[0].intTipoBeca, resPer.carrera[0].strCodigo, resAjusteAnt.becas[0].intAdmite, resAjusteAnt.becas[0].intActualizar,
            resAjusteAnt.becas[0].strCondiciones, resAjusteAnt.becas[0].strMailCargaReq, resAjusteAnt.becas[0].strMailEntregaReq, resAjusteAnt.becas[0].strMailObservaReq,
            resAjusteAnt.becas[0].datFechaPostula, resAjusteAnt.becas[0].datFechaCarga, resAjusteAnt.becas[0].intPersona, resAjusteAnt.becas[0].datFecha, resAjusteAnt.becas[0].fltPromedioMin);
          this.guardarCambios();
        }
      }
    }
    else
      this.alerti.warning('A la fecha Actual no hay período académico vigemte');
  }
  //GENERAR EL VECTOR DE HORAS Y MINUTOS
  generarHorasMinutos() {
    this.vecHora = []; this.vecMin = [];
    for (let i = 1; i < 24; i++)
      this.vecHora.push({ hora: i });
    for (let j = 1; j < 60; j++)
      this.vecMin.push({ min: j });
  }
  //FUNCION QUE SE EEJECUTA EN EL BOTON GUARDAR CAMBIOS
  guardarCambios() {
    this.registroCambios(this.vecAjustes[0].intTipoBeca, this.vecAjustes[0].strPeriodo, this.vecAjustes[0].intAdmite, this.vecAjustes[0].intActualizar,
      this.vecAjustes[0].strCondiciones, this.vecAjustes[0].strMailCargaReq, this.vecAjustes[0].strMailEntregaReq, this.vecAjustes[0].strMailObservaReq,
      localStorage.getItem('idPersona'), this.vecAjustes[0].datFechaPostula + ' ' + this.vecAjustes[0].datHoraPostula + ':' + this.vecAjustes[0].datMinPostula,
      this.vecAjustes[0].datFechaCarga + ' ' + this.vecAjustes[0].datHoraCarga + ':' + this.vecAjustes[0].datMinCarga, this.vecAjustes[0].promedio, 'na');
  }
  //FUNCION QUE GUARDA LOS CAMBIOS EN LOS AJUSTES
  registroCambios(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, dato11, dato12, dato13) {
    this.srvInsert.ingresoGestionBecas(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, dato11, dato12, dato13, 'na', 17).subscribe(res => {
      if (res.becas) {
        this.alerti.success('Datos actualizados');
        this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), 'ANALISTA BECAS', 'ingresoAjustes()', 'Ajustes Beca: ' + localStorage.getItem('modBeca'),
          17, ' Periodo - ' + this.vecAjustes[0].strPeriodo + '; Admite - ' + this.vecAjustes[0].intAdmite + '; F. Postula  - ' + this.vecAjustes[0].datFechaPostula + ' ' +
          this.vecAjustes[0].datHoraPostula + ':' + this.vecAjustes[0].datMinPostula + '; F. Carga - ' + this.vecAjustes[0].datFechaCarga + ' ' +
          this.vecAjustes[0].datHoraCarga + ':' + this.vecAjustes[0].datMinCarga + '; Promedio Mínimo: ' + this.vecAjustes[0].promedio, 1).subscribe(res => { });

      }

    });
  }
}

